<div class="page-table-filter wrapper--spacing-horizontal">
  <h1 class="text--h1">{{ pageTitle }}</h1>

  <ng-content select="[tableIntro]"></ng-content>

  <div class="spacing--margin-bottom">
    <agr-filter
      [config]="filterConfig"
      [actions]="filterActions"
      [selectionTitle]="selectionText"
      [actionsTitle]="'export.export_as' | translate"
      [formControl]="filterControl"
      (action)="export($event)"
    ></agr-filter>
  </div>

  <agr-table
    [config]="tableConfig"
    (selectionChange)="setSelection($event)"
    [emptyTitle]="emptyTitle"
    [emptyDescription]="emptyDescription"
    [emptyImage]="emptyImage"
    [emptyActionIcon]="emptyActionIcon"
    [emptyActionText]="emptyActionText"
    [emptyActionColor]="emptyActionColor"
    [showEmptyAction]="showEmptyAction"
    [isEmpty]="this.tableConfig?.dataSource?.filteredData?.length === 0"
  ></agr-table>
</div>
